var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { LitElement } from "@horizon/base";
import { property } from "@horizon/base/decorators.js";
import iconStyles from "./icon.css.js";
class HznIconBase extends LitElement {
  constructor() {
    super(...arguments);
    this.variant = "stroked";
  }
  firstUpdated() {
    this.setAttribute("inert", "");
  }
}
HznIconBase.styles = [iconStyles];
__decorateClass([
  property({ type: String, reflect: true })
], HznIconBase.prototype, "size", 2);
__decorateClass([
  property({ type: String })
], HznIconBase.prototype, "variant", 2);
export {
  HznIconBase
};
//# sourceMappingURL=icon-base.js.map
